import styled from 'styled-components';
import { mixins, styles } from '4all-ui/styles';

export const OrderListContainer = styled.div`
  max-height: 470px;
  width: calc(100% + 6px);
  height: 100%;
  overflow-y: scroll;
  box-sizing: content-box;
  ${mixins.customScrollbar()}
`;

export const EmptyContainer = styled.div`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_6,
    styles.fontWeights.NORMAL
  )}
  height: 260px;
  ${mixins.flexPosition({ align: 'center', justify: 'center', direction: 'column' })}
`;

export const Icon = styled.div`
  margin-bottom: 15px;
`;

export const EmptyContainerText = styled.p`
  margin: 0;
  font-size: ${styles.fontSizes.SIZE_6};
  font-size: ${styles.fontWeights.SEMIBOLD};

  ${({ error }) => (error ? `color: ${styles.colors.DANGER_COLOR}` : {})}
`;



// WEBPACK FOOTER //
// ./src/components/OrderList/SearchResultsBox/style.js